(function () {
  const navToggle = document.querySelector("[data-nav-toggle]");
  const nav = document.querySelector("[data-site-nav]");

  if (navToggle && nav) {
    const closeNavigation = function () {
      nav.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
    };

    navToggle.addEventListener("click", function () {
      const isOpen = nav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    nav.addEventListener("click", function (event) {
      if (event.target.closest("a")) closeNavigation();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && nav.classList.contains("is-open")) {
        closeNavigation();
        navToggle.focus();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 920) closeNavigation();
    });
  }

  const heroInstances = new WeakMap();

  function initHero(hero) {
    if (!hero || heroInstances.has(hero)) return;
    const slides = Array.from(hero.querySelectorAll("[data-avsg-hero-slide]"));
    const dots = Array.from(hero.querySelectorAll("[data-avsg-hero-dot]"));
    if (slides.length < 2) return;

    const abortController = new AbortController();
    const signal = abortController.signal;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const interval = Math.max(3000, Number(hero.dataset.avsgHeroInterval) || 3000);
    let current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains("is-active"); }));
    let timer = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle("is-active", slideIndex === current);
      });
      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === current;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", active ? "true" : "false");
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }

    function start() {
      stop();
      if (reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(function () { show(current + 1); }, interval);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        show(index);
        start();
      }, { signal: signal });
    });
    hero.addEventListener("focusin", stop, { signal: signal });
    hero.addEventListener("focusout", function (event) {
      if (!hero.contains(event.relatedTarget)) start();
    }, { signal: signal });
    document.addEventListener("visibilitychange", start, { signal: signal });
    reducedMotion.addEventListener?.("change", start, { signal: signal });

    heroInstances.set(hero, {
      destroy: function () {
        stop();
        abortController.abort();
        heroInstances.delete(hero);
      }
    });
    show(current);
    start();
  }

  function scanHeroes(root) {
    if (root.matches?.("[data-avsg-hero]")) initHero(root);
    root.querySelectorAll?.("[data-avsg-hero]").forEach(initHero);
  }

  scanHeroes(document);
  document.addEventListener("shopify:section:load", function (event) { scanHeroes(event.target); });
  document.addEventListener("shopify:section:unload", function (event) {
    const hero = event.target.matches?.("[data-avsg-hero]") ? event.target : event.target.querySelector?.("[data-avsg-hero]");
    heroInstances.get(hero)?.destroy();
  });

  const query = new URLSearchParams(window.location.search);
  const design = query.get("design");
  const interest = query.get("interest");
  const contactForm = document.querySelector(".contact-form");
  const ringReference = query.get("ring_ref");

  if (contactForm && design) {
    const message = contactForm.querySelector('textarea[name="contact[body]"]');
    const interestSelect = contactForm.querySelector('select[name="contact[interest]"]');

    if (message && !message.value) message.value = design;
    if (interestSelect && interest) {
      const matchingOption = Array.from(interestSelect.options).find(function (option) {
        return option.text === interest;
      });
      if (matchingOption) interestSelect.value = matchingOption.value;
    }
  }

  if (contactForm && ringReference) {
    const referenceField = contactForm.querySelector("[data-avsg-contact-reference-field]");
    const configurationField = contactForm.querySelector("[data-avsg-contact-configuration-field]");
    if (referenceField) referenceField.value = ringReference;
    try {
      const record = JSON.parse(window.sessionStorage.getItem("aurumvitaRingEnquiry:latest"));
      if (record?.reference === ringReference) {
        const preview = contactForm.querySelector("[data-avsg-contact-design]");
        const image = contactForm.querySelector("[data-avsg-contact-design-image]");
        const reference = contactForm.querySelector("[data-avsg-contact-design-reference]");
        const details = contactForm.querySelector("[data-avsg-contact-design-details]");
        if (preview) preview.hidden = false;
        if (image && record.previewImage) {
          image.src = record.previewImage;
          image.draggable = false;
          image.addEventListener("contextmenu", function (event) { event.preventDefault(); });
        }
        if (reference) reference.textContent = `Design reference: ${record.reference}`;
        if (configurationField) configurationField.value = Object.entries(record.labels || {}).map(function (entry) {
          return `${entry[0]}: ${entry[1]}`;
        }).join(" | ");
        if (details) {
          Object.entries(record.labels || {}).forEach(function (entry) {
            const term = document.createElement("dt");
            const description = document.createElement("dd");
            term.textContent = entry[0].replaceAll("-", " ");
            description.textContent = entry[1];
            details.append(term, description);
          });
        }
      }
    } catch (error) {
      console.warn("AurumVita contact form: private ring preview could not be restored.", error);
    }
  }
})();
